var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_174",
    "data-name": "Group 174",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.418,
    height: 22.923,
    viewBox: "0 0 25.418 22.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 25.418,
    height: 22.923,
    transform: "translate(0 0)",
    fill: "#efe8d9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_174-2",
    "data-name": "Group 174",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M8.621,5.391,16.2.093a.5.5,0,0,1,.525-.035A.5.5,0,0,1,17,.508v21.9a.507.507,0,0,1-.8.415l-7.577-5.3H1.015A1.017,1.017,0,0,1,0,16.515V6.406A1.017,1.017,0,0,1,1.015,5.391Z",
    transform: "translate(0 0.001)",
    fill: "#efe8d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M80.32,32.907l-1.971,1.968-1.968-1.968-.957.955,1.971,1.969L75.423,37.8l.957.955,1.968-1.968,1.971,1.968.956-.955L79.3,35.831l1.971-1.969Z",
    transform: "translate(-55.857 -24.37)",
    fill: "#efe8d9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicOff);
export default __webpack_public_path__ + "static/media/music-off.84a74ce0a40d96f043c1ea4209e38d36.svg";
export { ForwardRef as ReactComponent };